import styled from 'styled-components';

export const SCDiv = styled.div``;
export const SCOverlayWrapper = styled.div`
    width: 100%;
    height: 100vh;
    background-color: rgba(255, 255, 255, 1);
`;
